import { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useFirebase } from 'react-redux-firebase';
import CustomizedSnackbars from "./Feedback";
import * as EmailValidator from 'email-validator';
import { FaArrowLeft } from 'react-icons/fa';

const useStyles = makeStyles({
    field: {
        marginTop: 25,    
    },
    btn: {
        marginBottom: 20,
        marginTop: 30,
        paddingTop: 8,
        paddingBottom: 8,
        backgroundColor: '#48c78e',
        color: '#fff',
        fontWeight: '600'
    }
});

const ForgotPwd = () => {
    const classes = useStyles();
    const [ email, setEmail ] = useState('');
    const [ error, setError ] = useState(null);
    const [emailSent, setEmailSent] = useState(false);

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const firebase = useFirebase();

    const history = useHistory();

    const handleReset = (e) => {
        e.preventDefault();

        if(email !== '' && EmailValidator.validate(email)) {
            setError(null); 
            document.getElementById('Btn').innerHTML = 'Loading';

            var auth = firebase.auth();
              

            auth.sendPasswordResetEmail(email).then(() => {
                setFeedbackText('Please check your email inbox for password reset link.');
                setSeverity('success');
                setOpenFeedback(true);

                document.getElementById('Btn').innerHTML = 'Reset Password';
                setEmailSent(true)
                
                
            })
            .catch((error) => {
                document.getElementById('Btn').innerHTML = 'Reset Password';
                // //on error
                setFeedbackText(error.message);
                setSeverity('error');
                setOpenFeedback(true);

            });      
        } else {
           setError('Please provide an email.');    
        }
    }

    return ( 
        <>
            <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic is Registered with the Ministry of Higher And Tertiary Education, Science and Technology Development."
                />
                <title>Reset Password</title>
            </Helmet>
            <div className="wrapper light-bg py-3">
                <div className="container">
                    <div className="center">
                        <h4 className="is-size-4-touch is-size-3-desktop has-text-weight-bold grey-text text-darken-2">Life Long Polytechnic</h4>
                    </div>
                    <div className="center">
                        <img src="/img/logo.png" alt="Life Long Polytechnic Logo" className="logo-form2 mb-3" />
                    </div>
                    <div className="row">
                        <div className="col s12 m8 l6 offset-m2 offset-l3 box center px-6 py-3">
                            <form noValidate autoComplete="off" className="bb-none" onSubmit={handleReset}>
                                {
                                     !emailSent ? (
                                        <p className="grey-text text-darken-1 my-3">Please enter your email and a reset password link will be sent to your email.</p>
                                     ) : (
                                        <p className="grey-text text-darken-1 my-3">Please check your email inbox for password reset link.</p>
                                     )
                                }
                                <TextField 
                                    type="email"
                                    label="Email"
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.field}
                                    fullWidth
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                    disabled={emailSent}
                                />
                                {
                                    !emailSent ? (
                                        <Button
                                            className={classes.btn}
                                            type="submit"
                                            color="secondary"
                                            variant="contained"
                                            fullWidth
                                            id="Btn"
                                        >
                                            Reset Password
                                        </Button>

                                    ): (
                                        <div className="container center">
                                            <div className="control mb-4">
                                                <div onClick={() => history.goBack()} className="button is-rounded is-success mt-3 mb-4">
                                                    <span className="icon">
                                                        <FaArrowLeft color="white"/>
                                                    </span>
                                                    <span className="white-text">Previous Page</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    error && <p className="main-color-text">{error}</p>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">          
                    <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
            </div>
        </>
     );
}
 
export default ForgotPwd;